import { useTheme } from 'styled-components';
import { Icon, IconButton } from '@workramp/ui';
import TrainingSearchBar from '~/components/training-search-bar/training-search-bar';
import { LEARNER_ROUTES } from '../../constants';
import { SearchWrapper, SearchBarWrapper, StyledSearchIcon, StyledAdvancedSearch } from './Header.styles';

const { I18n } = window;

const TRANSLATED_ADVANCED = I18n.t('js.learner.search.advanced');

export function HeaderSearchBar() {
  const theme = useTheme();

  return (
    <SearchWrapper>
      <SearchBarWrapper>
        <TrainingSearchBar hideAdvancedSearch />
      </SearchBarWrapper>

      <StyledSearchIcon>
        <Icon name="search:regular" color={theme.colors.on[600]} />
      </StyledSearchIcon>

      <StyledAdvancedSearch>
        <IconButton
          href={LEARNER_ROUTES.search}
          label={TRANSLATED_ADVANCED}
          iconName="controls-preferences:regular"
          variant="text"
          color="secondary"
        />
      </StyledAdvancedSearch>
    </SearchWrapper>
  );
}
